<template>
  <div id="agreement-container" ref="main" class="slideUp">
    <div class="header">
      <div class="left">
        <h1 class="section-header">请阅读服务条款</h1>
        <h2>详细阅读后在底部点击同意。</h2>
      </div>
      <div class="right">
        <i class="agreement-close anyteachicon anyteach-guanbi" @click="end(false)" />
      </div>
    </div>
    <Terms />
    <div class="blue-button button-pop" @click="end(true)">我已阅读并同意服务条款</div>
  </div>
</template>
<script>
import Terms from "../../my/agreement"
export default {
  name: "Agreement",
  components: {
    Terms,
  },
  created() {
    this.$disableScroll()
  },
  methods: {
    end(state) {
      this.$refs.main.classList.remove("slideUp")
      this.$refs.main.classList.add("slideDown")
      setTimeout(() => {
        this.$emit("state", state)
        this.$enableScroll()
      }, 300)
    },
  },
}
</script>
<style scoped lang="scss">
// @import "../../../../static/css/public.scss";
@import "../../../../static/css/transaction.scss";
@import "../../../../static/css/prog-form.scss";

#agreement-container {
  height: 100%;
  width: 100%;
  position: fixed;
  background: white;
  top: 0;
  left: 0;
  z-index: 3;
  overflow: scroll !important;
  padding-top: 15px;
  border-radius: 4px;
  .blue-button {
    text-align: center;
    margin: 0 auto 30px auto;
    position: relative;
  }
  .header {
    border-bottom: 1px solid #eee;
    margin: 0 5%;
    padding: 0 0 20px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .agreement-close {
      opacity: 0.6;
    }
  }
  .section-header {
    margin: 0;
    padding: 0;
    line-height: 1.7;
    font-size: 1.2rem;
    @include avenir-demi();
  }
  h2 {
    padding: 0;
    font-size: 0.9rem;
    @include avenir();
    opacity: 0.6;
    font-weight: 400;
    margin: 0;
  }
}
</style>
